import React, { useEffect, useState } from "react";
import PersonalInformation from "./PersonalInformation/PersonalInformation";
import Billing from "./Billing/Billing";
import Terms from "./Terms";
import Security from "./Security/Security";
import TwoFactorMFA from "./TwoFactorMFA/TwoFactorMFA";
import PersonalInformationEnd from "./PersonalInformationEnd/PersonalInformationEnd";
import { states, updateState, FirstTermsStates } from "./StateManagement";
import * as httpClient from "../../util/httpClient";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";

const RegistrationComponents = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const location = useLocation();
    const components: any = {
        PersonalInformation,
        Billing,
        Security,
        TwoFactorMFA,
        PersonalInformationEnd,
        Terms,
    };
    const query = new URLSearchParams(location.search);
    const LookupType: any = query.get("Type");
    const tosAccepted: any = query.get("TOSAccepted");
    const Gndrll: any = query.get("GNDNRLL");
    const [displayData, setDisplayData] = useState();
    const [state, manageState] = useState([]);
    const [registrationState, setRegistrationState] = useState({
        personalInfo: {},
        addressInfo: {},
        billingInfo: {},
        PaymentMode: {},
        securityInfo: {},
        twoFactorMFA: {},
        NotificationPreference: {},
        monitorPrimaryEmail: false,
        proofInfo: {
            writtenInstruction: "",
            automaticRenewal: "",
            automaticRenewalTermsAcceptance: "",
        },
    });
    const isCignaPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2559
                ? true
                : false
            : false
    );
    const preferredUserLanguage = sessionStorage.getItem('preferredLanguage');
    
    const isTypeSSOProvisional = LookupType === "SSO_PROVISIONAL";
    const lookUpTypes = ["WALKUP", "SSSOFFER"];
    const isTOSAccepted = tosAccepted === "true";
    const ShowTermsAndConditionScreenFirst: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.showTermsAndConditionScreenFirst
            : false
    );
    const IsWhiteLabeled: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );
    const [billingRequired, setBillingRequired] = useState(false);

    useEffect(() => {
        let languageId = (preferredUserLanguage === 'en') ? 1 : ((preferredUserLanguage === 'fr') ? 2 : 1);
        httpClient.sendRequest("GET", "web/partner/GetRegDisplayOption?languageId=" + languageId).then((data: any) => {
            if (isCignaPartner) {
                try {
                    delete data.regDisplayOptionDetails.packageLookup.packageServicesList["Family Protection Plus"];
                } catch (err) {}
            }

            if (data.regDisplayOptionDetails.isTUUser) {
                data.regDisplayOptionDetails.displayFullSSN = false;
            }
            setDisplayData(data.regDisplayOptionDetails);
        });
    }, [preferredUserLanguage]);

    useEffect(() => {
        const displayOptions: any = displayData;
        if (displayOptions) {
            let paymentMethod =
                displayOptions.billingOptions && displayOptions.billingOptions.paymentOptions && displayOptions.billingOptions.paymentOptions.paymentMethod
                    ? displayOptions.billingOptions.paymentOptions.paymentMethod
                    : null;
            setBillingRequired(displayOptions["billingRequired"]);
            if (ShowTermsAndConditionScreenFirst && isTypeSSOProvisional) {
                manageState(updateState(FirstTermsStates, displayOptions["billingRequired"], 1));
            } else {
                manageState(updateState(states, displayOptions["billingRequired"], 1));
            }
            const query = new URLSearchParams(location.search);
            const SubType = query.get("SUBTYPE");

            if (SubType) {
                setRegistrationState({ ...registrationState, PaymentMode: { SubscriptionType: SubType === "ANNUAL" ? "annual" : "monthly" } });
            }
            if (paymentMethod && paymentMethod.options && paymentMethod.options.includes("CC") && !paymentMethod.options.includes("EFT")) {
                setRegistrationState({ ...registrationState, billingInfo: { ...registrationState.billingInfo, paymentMethod: "CC" } });
            }
            if (paymentMethod && paymentMethod.options && !paymentMethod.options.includes("CC") && paymentMethod.options.includes("EFT")) {
                setRegistrationState({ ...registrationState, billingInfo: { ...registrationState.billingInfo, paymentMethod: "EFT" } });
            }
            if (displayOptions && displayOptions.monitorPrimaryEmail) {
                setRegistrationState({ ...registrationState, monitorPrimaryEmail: displayOptions.monitorPrimaryEmail });
            }
            if (!displayOptions["displayLast4SSN"] && !displayOptions["displayFullSSN"]) {
                states[5]["label"] = "registration.tabs.complete";
            }
        }
    }, [displayData]);

    useEffect(() => {
        if (((Gndrll && Gndrll.includes('PSS') && !IsWhiteLabeled) || (lookUpTypes.includes(LookupType.toUpperCase()))) && !billingRequired) {
            states[2]["isHide"] = true;
        }
        if (isTypeSSOProvisional) {
            states[3]["isHide"] = true;
            states[4]["isHide"] = true;
        }
        if (isTOSAccepted) {
            FirstTermsStates[0]["isHide"] = true;
        }
    }, []);

    return (
        <>
            {displayData && (
                <div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="timeline-container">
                                <ol className={`timeline steps-${state.length}`}>
                                    {displayData &&
                                        state.map((state: any, index: number) => (
                                            <li key={index} data-label={index + 1} className={state.status}>
                                                <span className="sr-only">Current Step: </span>
                                                <span>{tLang(state.label)}</span>
                                            </li>
                                        ))}
                                </ol>
                            </div>
                        </div>
                    </div>
                    {React.createElement(
                        components[
                            state.filter((state: any) => state.status === "timeline-current")[0]
                                ? state.filter((state: any) => state.status === "timeline-current")[0]["name"]
                                : "PersonalInformation"
                        ],
                        {
                            manage: manageState,
                            displayData: displayData,
                            registrationState: registrationState,
                            setRegistrationState: setRegistrationState,
                            registrationLookup: props.registrationLookup,
                        }
                    )}
                </div>
            )}
        </>
    );
};

export default RegistrationComponents;
